// extracted by mini-css-extract-plugin
export default {"error":"ValidatedRecaptcha_error__+ZJR1","recaptcha":"ValidatedRecaptcha_recaptcha__kPtHJ"};